import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../api/index";
import { IError } from "../types/common";
import { ILocationNameSelector } from "./types";
import { IGetParams } from "../../api/types";

export const getLocationNamesSelectors = createAsyncThunk<
  ILocationNameSelector[],
  IGetParams | undefined,
  { rejectValue: IError }
>(
  "locationNames/getLocationNamesSelectors",
  async (params, { rejectWithValue }) => {
    try {
      return await API.getLocationNamesSelectors(params);
    } catch (error) {
      const { data } = error as {
        data: IError;
      };
      return rejectWithValue({ ...data });
    }
  }
);
